import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';
import { DwMenu, DwMenuBuilderService, DwMenuCategory, DwMenuService, DwSecurityUserService } from '@devwareapps/devware-cap';
import { FitnessCommerceService } from '../commerce/services/fitness-commerce.service';

@Component({
  selector: 'streakers-navigation',
  templateUrl: './streakers-navigation.component.html',
  styleUrls: ['./streakers-navigation.component.scss'],
})
export class StreakersNavigationComponent implements OnDestroy {
  readonly menus$: Observable<DwMenu[]>;
  readonly authenticated$: Observable<boolean>;
  menuOpen = false;
  private readonly destroyed$ = new Subject<void>();

  constructor(menus: DwMenuService, builder: DwMenuBuilderService, security: DwSecurityUserService, router: Router, public commerce: FitnessCommerceService) {
    this.menus$ = combineLatest([
      menus.menuStateObservable,
      security.securityContextChanged().pipe(startWith(null)),
    ]).pipe(map(([state]) => state?.menusByCategory
      ? this.withoutStats(builder.securityTrimMenus(menus.getMenuHierarchy(DwMenuCategory.topMenu))) : []));
    this.authenticated$ = security.securityContextChanged().pipe(
      startWith(null), map(() => security.securityState.isAuthenticated));
    router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.destroyed$))
      .subscribe(() => this.menuOpen = false);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private withoutStats(items: DwMenu[]): DwMenu[] {
    return items.filter(item => !['stats', 'teams', 'discover teams', 'my profile'].includes((item.display || '').trim().toLowerCase()))
      .map(item => ({ ...item, children: item.children ? this.withoutStats(item.children) : item.children }));
  }
}
